import HttpMethod from './httpMethods'
import axios, { AxiosResponse } from 'axios';
import { ApiResponse } from './types';

export async function makeRequest(method: string, url: string, object: Object): Promise<ApiResponse> {
    
    let response: AxiosResponse<any>;
    try {
        switch (method) {
            case HttpMethod.GET:
                response = await axios.get(url, { params: object })
                break;
            case HttpMethod.POST:
                response = await axios.post(url, object)
                break;
            case HttpMethod.PUT:
                response = await axios.put(url, object)
                break;
            case HttpMethod.DELETE:
                response = await axios.delete(url, { params: object })
                break;
            default:
                throw new Error('Invalid Method')
        }
        return {
            StatusCode: response.status,
            Response: response.data,
            Error: null
        }
    } catch (error:any) {
        return {
            StatusCode: error.response.status,
            Response: null,
            Error: error.response.data
        }
    }
}